export default {
  nl: {
    title: 'Programma beheren',
    selectColumns: 'Kolommen selecteren',
    export: 'Exporteren',
    exportFilename: 'BeheerDocumenten',
    editRecord: 'Record bewerken',
    deleteRecord: 'Record verwijderen',
    confirmTitle: 'Bevestigen',
    confirmDelete: 'Weet je zeker dat je record met ID {id} en klantnaam {client} wilt verwijderen?',
    no: 'Nee',
    yes: 'Ja',
    documentDetails: 'Documentdetails',
    cancel: 'Annuleren',
    save: 'Opslaan',
    fields: {
      id: 'ID',
      customerid: 'Klant-ID',
      application: 'Applicatie',
      address: 'Adres',
      address2: 'Adres 2',
      designer: 'Ontwerper',
      client: 'Klant',
      commission: 'Commissie',
      comment: 'Opmerking',
      comment2: 'Opmerking 2',
      description: 'Omschrijving',
      path: 'Pad',
      assemblydate: 'Montagedatum',
      created: 'Aangemaakt op',
      deliverydate: 'Leverdatum',
      productionstartdate: 'Startdatum productie'
    },
    errors: {
      noExportData: 'Er zijn geen gegevens beschikbaar om te exporteren.',
      saveFailed: 'Het document kon niet worden opgeslagen. Probeer het opnieuw.',
      deleteFailed: 'Het record kon niet worden verwijderd. Probeer het opnieuw.',
      network: 'De server is niet bereikbaar. Controleer je verbinding en probeer het opnieuw.',
      loadFailed: 'De documenten konden niet worden opgehaald. Probeer het opnieuw.'
    }
  },
  en: {
    title: 'Program management',
    selectColumns: 'Select columns',
    export: 'Export',
    exportFilename: 'DocumentManagement',
    editRecord: 'Edit record',
    deleteRecord: 'Delete record',
    confirmTitle: 'Confirm',
    confirmDelete: 'Are you sure you want to delete the record with ID {id} and client name {client}?',
    no: 'No',
    yes: 'Yes',
    documentDetails: 'Document details',
    cancel: 'Cancel',
    save: 'Save',
    fields: {
      id: 'ID',
      customerid: 'Customer ID',
      application: 'Application',
      address: 'Address',
      address2: 'Address 2',
      designer: 'Designer',
      client: 'Client',
      commission: 'Commission',
      comment: 'Comment',
      comment2: 'Comment 2',
      description: 'Description',
      path: 'Path',
      assemblydate: 'Assembly date',
      created: 'Created on',
      deliverydate: 'Delivery date',
      productionstartdate: 'Production start date'
    },
    errors: {
      noExportData: 'There is no data available to export.',
      saveFailed: 'The document could not be saved. Please try again.',
      deleteFailed: 'The record could not be deleted. Please try again.',
      network: 'The server cannot be reached. Check your connection and try again.',
      loadFailed: 'The documents could not be loaded. Please try again.'
    }
  },
  fr: {
    title: 'Gestion du programme',
    selectColumns: 'Sélectionner les colonnes',
    export: 'Exporter',
    exportFilename: 'GestionDocuments',
    editRecord: 'Modifier l’enregistrement',
    deleteRecord: 'Supprimer l’enregistrement',
    confirmTitle: 'Confirmer',
    confirmDelete: 'Voulez-vous vraiment supprimer l’enregistrement portant l’ID {id} et le nom de client {client} ?',
    no: 'Non',
    yes: 'Oui',
    documentDetails: 'Détails du document',
    cancel: 'Annuler',
    save: 'Enregistrer',
    fields: {
      id: 'ID',
      customerid: 'Identifiant client',
      application: 'Application',
      address: 'Adresse',
      address2: 'Adresse 2',
      designer: 'Concepteur',
      client: 'Client',
      commission: 'Commission',
      comment: 'Commentaire',
      comment2: 'Commentaire 2',
      description: 'Description',
      path: 'Chemin',
      assemblydate: 'Date de montage',
      created: 'Créé le',
      deliverydate: 'Date de livraison',
      productionstartdate: 'Date de début de production'
    },
    errors: {
      noExportData: 'Aucune donnée n’est disponible pour l’exportation.',
      saveFailed: 'Le document n’a pas pu être enregistré. Veuillez réessayer.',
      deleteFailed: 'L’enregistrement n’a pas pu être supprimé. Veuillez réessayer.',
      network: 'Le serveur est inaccessible. Vérifiez votre connexion et réessayez.',
      loadFailed: 'Les documents n’ont pas pu être chargés. Veuillez réessayer.'
    }
  },
  de: {
    title: 'Programmverwaltung',
    selectColumns: 'Spalten auswählen',
    export: 'Exportieren',
    exportFilename: 'Dokumentverwaltung',
    editRecord: 'Datensatz bearbeiten',
    deleteRecord: 'Datensatz löschen',
    confirmTitle: 'Bestätigen',
    confirmDelete: 'Möchten Sie den Datensatz mit der ID {id} und dem Kundennamen {client} wirklich löschen?',
    no: 'Nein',
    yes: 'Ja',
    documentDetails: 'Dokumentdetails',
    cancel: 'Abbrechen',
    save: 'Speichern',
    fields: {
      id: 'ID',
      customerid: 'Kunden-ID',
      application: 'Anwendung',
      address: 'Adresse',
      address2: 'Adresse 2',
      designer: 'Konstrukteur',
      client: 'Kunde',
      commission: 'Kommission',
      comment: 'Kommentar',
      comment2: 'Kommentar 2',
      description: 'Beschreibung',
      path: 'Pfad',
      assemblydate: 'Montagedatum',
      created: 'Erstellt am',
      deliverydate: 'Lieferdatum',
      productionstartdate: 'Produktionsstartdatum'
    },
    errors: {
      noExportData: 'Es sind keine Daten zum Exportieren verfügbar.',
      saveFailed: 'Das Dokument konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      deleteFailed: 'Der Datensatz konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
      network: 'Der Server ist nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      loadFailed: 'Die Dokumente konnten nicht geladen werden. Bitte versuchen Sie es erneut.'
    }
  }
};
